import { BlocksIconShopHistory } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shop-history';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShopHistory = createComponent({ react: React, tagName: 'cat-icon-shop-history', elementClass: BlocksIconShopHistory });
